<template>
  <div class="loading-container" v-if="show">
    <img src="@/assets/loading/mobile-loading.gif" alt="加载动画">
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  name: 'Loading',
  data () {
    return {
      show: false
    }
  },
  watch: {
    loading: function (val) {
      this.show = val
    }
  }
}
</script>

<style>
.loading-container {
  position: absolute;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.45);
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue